import React from 'react';

/**
 * Component displayed while loading more rows
 */
export const LoadingMoreState: React.FC = () => {
  return (
    <tr>
      <td colSpan={13} className="px-4 py-8 text-sm bg-gradient-to-r from-blue-50/50 to-indigo-50/30 text-center">
        <div className="flex items-center justify-center gap-3">
          <div className="relative">
            <div className="animate-spin rounded-full h-6 w-6 border-2 border-blue-200 border-t-blue-600"></div>
            <div
              className="absolute inset-0 rounded-full h-6 w-6 border-2 border-transparent border-t-blue-400 animate-spin"
              style={{
                animationDirection: 'reverse',
                animationDuration: '1.5s',
              }}
            ></div>
          </div>
          <span className="text-gray-600 font-medium">Loading more rows...</span>
        </div>
      </td>
    </tr>
  );
};
